<span [matMenuTriggerFor]="menu" #menuTrigger="matMenuTrigger" (click)="verificarMutuos()">
  <i class="fa-solid fa-ellipsis-vertical menu-base"></i>
</span>

<mat-menu #menu="matMenu" class="add_factoring">
  <button mat-menu-item 
        class="align-content" 
        (click)="dowloadMutuo($event)" 
        [disabled]="!mutuoUrlStatus[this.pk] || spinner || status_document !== 'Firmado'" 
        [matTooltip]="!mutuoUrlStatus[this.pk] ? 
          ((tipoContrato === 'MUTUO' || tipoContrato === 'SIMPLI PLUS') ? 
            'No hay mutuo disponible para descargar' : 
            'No hay pagaré disponible para descargar') : 
          (status_document !== 'Firmado' ? 
            'El documento aún no ha sido firmado' : 
            '')"
        [matTooltipDisabled]="mutuoUrlStatus[this.pk] && status_document === 'Firmado' || spinner">
    <i class="fa-light fa-arrow-down-to-line menu-icon"></i>
    <span *ngIf="!spinner">
      Descargar {{(tipoContrato === 'MUTUO' || tipoContrato === 'SIMPLI PLUS') ? 'mutuo' : 'pagaré'}}
    </span>
    <span *ngIf="spinner"><i class="fa-solid fa-spinner fa-spin-pulse"></i></span>
</button>


</mat-menu>